import React, { useContext, useEffect, useState, lazy, Suspense } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid,
  TextField,
  IconButton,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import * as consts from "../../consts";
import { CSVLink } from "react-csv";
const CSVReader = React.lazy(() => import("react-csv-reader"));

export default function CSVUpload(props) {
  const [parsedFileName, setParsedFileName] = useState("");

  let columns = [];
  let csvLinkData = [];
  let csvLinkFilename = "";
  let cardDescription = "";

  const parsePlasticMeCSV = (data) => {
    let cardDetails = [];
    let shipping = {
      name: data[0].shipping_name ? data[0].shipping_name : "",
      company: data[0].shipping_company ? data[0].shipping_company : "",
      address: data[0].shipping_addres ? data[0].shipping_address : "",
      city: data[0].shipping_city ? data[0].shipping_city : "",
      state: data[0].shipping_state
        ? data[0].shipping_state
        : consts.DEFAULT_SHIPPING_STATE,
      zip: data[0].shipping_zip
        ? data[0].shipping_zip.toString().padStart(5, "0")
        : "",
      method: consts.DEFAULT_SHIPPING_METHOD,
    };
    data.map((row, index) => {
      let cardDetail = {
        to: row.to ? row.to : "",
        from: row.from ? row.from : "",
        email: "",
        deliveryDate: new Date(),
        message: row.message ? row.message : "",
        shipping: shipping,
      };
      cardDetails.push(cardDetail);
    });
    props.setCardDetails(cardDetails);
  };
  const parsePlasticThemCSV = (data) => {
    let cardDetails = [];
    data.map((row, index) => {
      let shippingState = row.shipping_state
        ? consts.STATES.find((item) => {
            return (
              item.abbreviation.toLowerCase() ==
              row.shipping_state.toLowerCase()
            );
          })
        : null;

      let cardDetail = {
        to: row.to ? row.to : "",
        from: row.from ? row.from : "",
        email: "",
        deliveryDate: new Date(),
        message: row.message ? row.message : "",
        shipping: {
          name: row.shipping_name ? row.shipping_name : "",
          company: row.shipping_company ? row.shipping_company : "",
          address: row.shipping_address ? row.shipping_address : "",
          city: row.shipping_city ? row.shipping_city : "",
          state: shippingState
            ? shippingState.abbreviation
            : consts.DEFAULT_SHIPPING_STATE,
          zip: row.shipping_zip
            ? row.shipping_zip.toString().padStart(5, "0")
            : "",
          method: consts.DEFAULT_SHIPPING_METHOD,
        },
      };
      cardDetails.push(cardDetail);
    });
    props.setCardDetails(cardDetails);
  };
  const parseEmailLaterCSV = (data) => {
    let cardDetails = [];
    data.map((row) => {
      let cardDetail = {
        to: row.to ? row.to : "",
        from: row.from ? row.from : "",
        email: row.email ? row.email : "",
        // deliveryDate: row.deliverydate
        //   ? new Date(Date.parse(row.deliverydate + "T00:00:00"))
        //   : new Date(),
        deliveryDate: props.cardDetails[0].deliveryDate
          ? props.cardDetails[0].deliveryDate
          : new Date(),
        message: row.message ? row.message : "",
        shipping: {
          name: "",
          company: "",
          address: "",
          city: "",
          state: consts.DEFAULT_SHIPPING_STATE,
          zip: "",
          method: consts.DEFAULT_SHIPPING_METHOD,
        },
      };
      cardDetails.push(cardDetail);
    });
    props.setCardDetails(cardDetails);
  };
  const parsePrinterCSV = (data) => {
    let cardDetails = [];
    data.map((row) => {
      let cardDetail = {
        to: row.to ? row.to : "",
        from: row.from ? row.from : "",
        email: "",
        deliveryDate: new Date(),
        message: row.message ? row.message : "",
        shipping: {
          name: "",
          company: "",
          address: "",
          city: "",
          state: consts.DEFAULT_SHIPPING_STATE,
          zip: "",
          method: consts.DEFAULT_SHIPPING_METHOD,
        },
      };
      cardDetails.push(cardDetail);
    });
    props.setCardDetails(cardDetails);
  };

  switch (props.cardType) {
    case consts.CARD_TYPE_PLASTIC:
      if (props.mailOption == consts.PLASTIC_TYPE_ME) {
        cardDescription = "Mail-Plastic-Cards-to-Me.csv";
        columns = [...consts.PLASTIC_ME_COLUMNS];
        csvLinkFilename = "Mail-Plastic-Cards-to-Me.csv";
        props.cardDetails.map((cardDetail) => {
          csvLinkData.push({
            from: cardDetail.from,
            to: cardDetail.to,
            message: cardDetail.message,
          });
        });
      } else {
        cardDescription = "Mail-Plastic-Cards-to-Recipient.csv";
        columns = [...consts.PLASTIC_THEM_COLUMNS];
        csvLinkFilename = "Mail-Plastic-Cards-to-Recipient.csv";
        props.cardDetails.map((cardDetail) => {
          csvLinkData.push({
            from: cardDetail.from,
            to: cardDetail.to,
            message: cardDetail.message,
            name: cardDetail.shipping ? cardDetail.shipping.name : "",
            company: cardDetail.shipping ? cardDetail.shipping.company : "",
            address1: cardDetail.shipping ? cardDetail.shipping.address1 : "",
            address2: cardDetail.shipping ? cardDetail.shipping.address2 : "",
            city: cardDetail.shipping ? cardDetail.shipping.city : "",
            state: cardDetail.shipping ? cardDetail.shipping.state : "",
            zip: cardDetail.shipping ? cardDetail.shipping.zip : "",
          });
        });
      }
      break;
    case consts.CARD_TYPE_EMAIL:
      cardDescription = "Email-Digital-Cards.csv";
      columns = [...consts.EMAIL_LATER_COLUMNS];
      csvLinkFilename = "Email-Digital-Cards.csv";
      props.cardDetails.map((cardDetail) => {
        csvLinkData.push({
          from: cardDetail.from,
          to: cardDetail.to,
          message: cardDetail.message,
          email: cardDetail.email,
          deliveryDate: cardDetail.deliveryDate,
        });
      });
      break;
    case consts.CARD_TYPE_PRINTER:
      cardDescription = "Printer-Cards.csv";
      columns = [...consts.PRINTER_COLUMNS];
      csvLinkFilename = "Printer-Cards.csv";
      props.cardDetails.map((cardDetail) => {
        csvLinkData.push({
          from: cardDetail.from,
          to: cardDetail.to,
          message: cardDetail.message,
        });
      });
      break;
  }
  let error = null;

  return (
    <Dialog
      open={props.bulkEntry}
      onClose={() => {
        props.onClose();
      }}
    >
      <DialogTitle>Upload Large Orders</DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <Typography component="div" variant="body1">
            Download this&nbsp;
            <CSVLink
              data={csvLinkData}
              headers={columns}
              filename={csvLinkFilename}
            >
              {cardDescription}
            </CSVLink>
            &nbsp;spreadsheet to create multiple cards. Be sure to save it as a
            .csv file and upload it here:
            <br />
            <Suspense fallback={null}>
              <div>
                <CSVReader
                  cssClass={props.classes.fileInput}
                  parserOptions={{
                    header: true,
                    dynamicTyping: true,
                    skipEmptyLines: true,
                    transformHeader: (header) =>
                      header.toLowerCase().replace(/\W/g, "_"),
                  }}
                  onFileLoaded={(data) => {
                    switch (props.cardType) {
                      case consts.CARD_TYPE_PLASTIC:
                        if (props.mailOption == consts.PLASTIC_TYPE_ME) {
                          parsePlasticMeCSV(data);
                        } else {
                          parsePlasticThemCSV(data);
                        }
                        break;
                      case consts.CARD_TYPE_EMAIL:
                        parseEmailLaterCSV(data);
                        break;
                      case consts.CARD_TYPE_PRINTER:
                        parsePrinterCSV(data);
                        break;
                    }
                    let input = document.getElementById(
                      "react-csv-reader-input"
                    );
                    let fullPath = input.value;
                    if (fullPath) {
                      let startIndex =
                        fullPath.indexOf("\\") >= 0
                          ? fullPath.lastIndexOf("\\")
                          : fullPath.lastIndexOf("/");
                      let filename = fullPath.substring(startIndex);
                      if (
                        filename.indexOf("\\") === 0 ||
                        filename.indexOf("/") === 0
                      ) {
                        filename = filename.substring(1);
                      }
                      setParsedFileName(filename);
                      setTimeout(function () {
                        props.onClose();
                      }, 3000);
                    }
                    input.value = "";
                  }}
                />
                <div>
                  {parsedFileName
                    ? "Successfully uploaded " + parsedFileName
                    : ""}
                </div>
              </div>
            </Suspense>
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
